import BATCH_DOCTOR_CONFIGS from './batchDoctorConfigs';

const DOCTOR_CONFIGS = {
  janakthakkar: {
    name: 'Dr. Janak Thakkar',
    clinic: 'Orna Skin',
    address: 'Dr Radha Krishnan Marg, Rajkot, Gujarat 360001',
    phone: '+919033790337',
    whatsappUrl: 'https://wa.me/919033790337?text=Hello%2C%20I%20just%20finished%20my%20AI%20skin%20analysis%20from%20your%20website%20at%20Orna%20Skin.%20I%20would%20like%20to%20book%20a%20consultation%20with%20you.',
    bookingUrl: null,
    mapsUrl: 'https://maps.app.goo.gl/zfccUygNcnXniLrx7',
    photoUrl: '/assets/janakthakkar.jpg',
    logoUrl: '/assets/janakthakkar.svg',
    logoAlt: 'Orna Skin',
    slug: 'janakthakkar',
    initials: 'JT',
    branches: null,
    welcomeStyle: 'minimal',
    photoSize: 'small',
    photoBorderClass: 'border-4',
    photoObjectClass: '',
    accentColor: '#E5097F',
    accentColorDark: '#C3076C',
    leftPaneSubtitleColor: null,
    rightPaneBg: null,
    clinicNameColor: 'text-[#E5097F]',
    fetchedImageBorder: 'border-[#E5097F]/20',
    fetchedImageFallbackFrom: '#E5097F',
    fetchedImageFallbackTo: '#C3076C',
    fetchedImageFallbackIcon: null,
    featureCardIconBg: 'bg-[#E5097F]/10',
    contactLinkText: null,
    contactLinkBg: null,
    contactLinkBorder: null,
    contactType: 'whatsapp',
    analysisAccent: '#E5097F',
    analysisAccentDark: '#E5097F',
    analysisAccentLight: '#E5097F',
    analysisTimerColor: '#E5097F',
    analysisScanGradient: false,
    analysisProgressGradient: false,
    routineTheme: {
      card: 'bg-gradient-to-r from-purple-50 to-pink-50',
      iconBg: 'bg-purple-100',
      iconText: 'text-purple-600',
      titleText: 'text-purple-900',
      bodyText: 'text-purple-800'
    },
    analysisDisclaimerFallback: 'This AI analysis is for informational purposes only. Please consult with Dr. Janak Thakkar for professional diagnosis and treatment recommendations.',
    analysisConsultFallback: 'Consult with Dr. Janak Thakkar for personalized recommendations.',
    pdfAccent: '#D97706',
    pdfAccentDark: null,
    pdfAccentLight: null,
    reportIdPrefix: 'SKN',
    footerName: 'Dr. Janak Thakkar',
    footerExtra: null,
    pdfContactExtraLine: null,
    followUpColors: { bg: '#FFF7ED', border: '#F97316', text: '#9A3412' },
    contactSectionBg: 'primary',
    keyConcernsBadge: { bg: '#FEF3C7', color: '#92400E' },
    pdfClinicName: 'Orna Skin Clinic, Rajkot',
    pdfPhone: '+91 90337 90337',
    pdfAddress: 'ornaskinclinic@gmail.com',
    pdfDisclaimer: 'This AI-powered skin analysis is for informational purposes only. Please consult Dr. Janak Thakkar for professional diagnosis and treatment.'
  },
  smitthakkar: {
    name: 'Dr. Smit Thakkar',
    clinic: 'OrnaSkin Laser & Hair care clinic',
    address: 'Pandit Dindayal Upadhyay Road,Madhur Nagar, Rajkot, Gujarat 360001',
    phone: '+919858598484',
    whatsappUrl: 'https://wa.me/919858598484?text=Hello%2C%20I%20just%20completed%20my%20AI%20Skin%20Analysis%20and%20would%20like%20to%20consult%20with%20your%20dermatologist.%0D%0A',
    bookingUrl: null,
    mapsUrl: 'https://maps.app.goo.gl/x5svm9xqHX7UCBRC9',
    photoUrl: '/assets/Smit.jpg',
    logoUrl: '/assets/janakthakkar.svg',
    logoAlt: 'OrnaSkin',
    slug: 'smitthakkar',
    initials: 'ST',
    branches: null,
    welcomeStyle: 'minimal',
    photoSize: 'small',
    photoBorderClass: 'border-4',
    photoObjectClass: '',
    accentColor: '#E5097F',
    accentColorDark: '#C3076C',
    leftPaneSubtitleColor: null,
    rightPaneBg: null,
    clinicNameColor: 'text-[#E5097F]',
    fetchedImageBorder: 'border-[#E5097F]/20',
    fetchedImageFallbackFrom: '#E5097F',
    fetchedImageFallbackTo: '#C3076C',
    fetchedImageFallbackIcon: null,
    featureCardIconBg: 'bg-[#E5097F]/10',
    contactLinkText: null,
    contactLinkBg: null,
    contactLinkBorder: null,
    contactType: 'whatsapp',
    analysisAccent: '#E5097F',
    analysisAccentDark: '#E5097F',
    analysisAccentLight: '#E5097F',
    analysisTimerColor: '#E5097F',
    analysisScanGradient: false,
    analysisProgressGradient: false,
    routineTheme: {
      card: 'bg-gradient-to-r from-pink-50 to-rose-50',
      iconBg: 'bg-pink-100',
      iconText: 'text-pink-600',
      titleText: 'text-pink-900',
      bodyText: 'text-pink-800'
    },
    analysisDisclaimerFallback: 'This AI analysis is for informational purposes only. Please consult with Dr. Smit Thakkar for professional diagnosis and treatment recommendations.',
    analysisConsultFallback: 'Consult with Dr. Smit Thakkar for personalized recommendations.',
    pdfAccent: '#E5097F',
    pdfAccentDark: '#C3076C',
    pdfAccentLight: null,
    reportIdPrefix: 'SKN',
    footerName: 'Dr. Smit Thakkar',
    footerExtra: null,
    pdfContactExtraLine: null,
    followUpColors: { bg: '#FDF2F8', border: '#E5097F', text: '#9D174D' },
    contactSectionBg: 'primary',
    keyConcernsBadge: { bg: '#FCE7F3', color: '#9D174D' },
    pdfClinicName: 'OrnaSkin Laser & Hair care clinic, Rajkot',
    pdfPhone: '+91 98585 98484',
    pdfAddress: 'Pandit Dindayal Upadhyay Road, Madhur Nagar, Rajkot, Gujarat 360001',
    pdfDisclaimer: 'This AI-powered skin analysis is for informational purposes only. Please consult Dr. Smit Thakkar for professional diagnosis and treatment.'
  },
  apratimgoel: {
    name: 'Dr. Apratim Goel',
    clinic: 'Oladerm',
    address: 'Cutis Skin Solution LLP, First Floor, Kukreja House, Opposite Khar Telephone Exchange, Khar West - 400052',
    phone: '+919833889680',
    whatsappUrl: 'https://wa.me/919967559680?text=Hello%2C%20I%20just%20completed%20my%20AI%20Skin%20Analysis%20and%20would%20like%20to%20book%20an%20appointment%20at%20Oladerm.',
    bookingUrl: null,
    mapsUrl: 'https://www.google.com/maps/search/?api=1&query=Cutis%20Skin%20Solution%20LLP%2C%20First%20Floor%2C%20Kukreja%20House%2C%20Opposite%20Khar%20Telephone%20Exchange%2C%20Khar%20West%20-%20400052',
    photoUrl: '/assets/oladerm-dr-apratim-goel.png',
    logoUrl: '/assets/oladerm.svg',
    pdfLogoUrl: '/assets/oladerm-pdf-logo.png',
    logoAlt: 'Oladerm',
    slug: 'apratimgoel',
    initials: 'AG',
    branches: [
      {
        name: 'Andheri',
        address: 'Cutis Skin Solution LLP, Sorrento, Shop - 002, Andheri West - 400102',
        mapsUrl: 'https://www.google.com/maps/search/?api=1&query=Cutis%20Skin%20Solution%20LLP%2C%20Sorrento%2C%20Shop%20-%20002%2C%20Andheri%20West%20-%20400102',
        isMain: true
      },
      {
        name: 'Khar',
        address: 'Cutis Skin Solution LLP, First Floor, Kukreja House, Opposite Khar Telephone Exchange, Khar West - 400052',
        mapsUrl: 'https://www.google.com/maps/search/?api=1&query=Cutis%20Skin%20Solution%20LLP%2C%20First%20Floor%2C%20Kukreja%20House%2C%20Opposite%20Khar%20Telephone%20Exchange%2C%20Khar%20West%20-%20400052',
        isMain: false
      }
    ],
    welcomeStyle: 'split-pane',
    photoSize: 'medium',
    photoBorderClass: 'border-0',
    photoObjectClass: '',
    photoRingStyle: 'double-accent',
    photoRingOuterStart: '#F36525',
    photoRingOuterEnd: '#D74E16',
    photoRingInner: '#FFF8F3',
    photoRingShadow: 'rgba(243, 101, 37, 0.34)',
    welcomeCardAccent: true,
    welcomeCardBorderColor: '#F9C8B0',
    welcomeCardShadow: '0 24px 56px rgba(243, 101, 37, 0.16)',
    accentColor: '#F36525',
    accentColorDark: '#D74E16',
    leftPaneSubtitleColor: 'text-[#FFE0D1]',
    rightPaneBg: 'bg-[#FFF6F0]',
    clinicNameColor: 'text-[#F36525]',
    fetchedImageBorder: 'border-[#F9C8B0]',
    fetchedImageFallbackFrom: null,
    fetchedImageFallbackTo: null,
    fetchedImageFallbackIcon: '#F7B393',
    featureCardIconBg: 'bg-[#FFE0D1]',
    contactLinkText: 'text-[#9C3911]',
    contactLinkBg: 'bg-[#FFE0D1]',
    contactLinkBorder: 'border-[#F9C8B0]',
    contactType: 'whatsapp',
    analysisAccent: '#F36525',
    analysisAccentDark: '#D74E16',
    analysisAccentLight: '#F89A73',
    analysisTimerColor: '#F36525',
    analysisScanGradient: true,
    analysisProgressGradient: true,
    routineTheme: {
      card: 'bg-gradient-to-r from-orange-50 to-amber-50',
      iconBg: 'bg-orange-100',
      iconText: 'text-orange-600',
      titleText: 'text-orange-900',
      bodyText: 'text-orange-800'
    },
    analysisDisclaimerFallback: 'This AI analysis is for informational purposes only. Please consult with Dr. Apratim Goel at Oladerm for professional diagnosis and treatment recommendations.',
    analysisConsultFallback: 'Consult with Dr. Apratim Goel at Oladerm for personalized recommendations.',
    pdfAccent: '#F36525',
    pdfAccentDark: '#D74E16',
    pdfAccentLight: '#F89A73',
    reportIdPrefix: 'OLD',
    footerName: 'Dr. Apratim Goel',
    pdfSpecialistName: 'Dr. Apratim Goel',
    pdfSpecialistQualifications: 'MBBS, MD, DNB, FAGE',
    pdfSpecialistOrganization: 'Oladerm | Cutis skin solutions',
    footerExtra: 'Andheri • Khar, Mumbai',
    pdfContactExtraLine: 'Andheri • Khar, Mumbai',
    followUpColors: { bg: '#FFF1EA', border: '#F36525', text: '#9C3911' },
    contactSectionBg: 'gradient',
    keyConcernsBadge: { bg: '#FFE4D7', color: '#9C3911' },
    pdfClinicName: 'Oladerm (Cutis Skin Solution LLP), Mumbai',
    pdfPhone: '+91 98338 89680',
    pdfAddress: 'Andheri: Sorrento, Shop-002 • Khar: First Floor, Kukreja House, Mumbai',
    pdfDisclaimer: 'This AI-powered skin analysis is for informational purposes only. Please consult Dr. Apratim Goel at Oladerm for professional diagnosis and treatment.'
  },
  harshitranpara: {
    name: 'Dr. Harshit Ranpara',
    clinic: 'ADIVA Center for Skin and Hair',
    address: 'Manhar Plot, Bhakti Nagar, Rajkot, Gujarat 360002',
    phone: '+919624559193',
    whatsappUrl: 'https://wa.me/919624559193?text=Hello%2C%20I%20just%20finished%20my%20AI%20skin%20analysis+%20from%20your%20website%20at%20ADIVA%20Center%20for%20Skin%20and%20Hair.%20I%20would%20like%20to%20book%20a%20consultation%20with%20you.',
    bookingUrl: null,
    mapsUrl: 'https://maps.app.goo.gl/sCZvvKvQh27PZLk46',
    photoUrl: '/assets/Harshit.jpg',
    logoUrl: '/assets/harshitranpara.svg',
    logoAlt: 'ADIVA',
    slug: 'harshitranpara',
    initials: 'HR',
    branches: null,
    welcomeStyle: 'split-pane',
    photoSize: 'small',
    photoBorderClass: 'border-4',
    photoObjectClass: '',
    accentColor: '#623085',
    accentColorDark: '#4A2464',
    leftPaneSubtitleColor: 'text-[#E1D4E8]',
    rightPaneBg: 'bg-[#F3EEF6]',
    clinicNameColor: 'text-[#623085]',
    fetchedImageBorder: 'border-[#E1D4E8]',
    fetchedImageFallbackFrom: null,
    fetchedImageFallbackTo: null,
    fetchedImageFallbackIcon: '#CBC0D3',
    featureCardIconBg: 'bg-[#E1D4E8]',
    contactLinkText: 'text-[#3B1D4F]',
    contactLinkBg: 'bg-[#E1D4E8]',
    contactLinkBorder: 'border-[#CBC0D3]',
    contactType: 'whatsapp',
    analysisAccent: '#EA580C',
    analysisAccentDark: '#EA580C',
    analysisAccentLight: '#EA580C',
    analysisTimerColor: '#EA580C',
    analysisScanGradient: false,
    analysisProgressGradient: false,
    routineTheme: {
      card: 'bg-gradient-to-r from-orange-50 to-amber-50',
      iconBg: 'bg-orange-100',
      iconText: 'text-orange-600',
      titleText: 'text-orange-900',
      bodyText: 'text-orange-800'
    },
    analysisDisclaimerFallback: 'This AI analysis is for informational purposes only. Please consult with Dr. Harshit Ranpata at ADIVA Center for Skin and Hair (+919624559193) for professional diagnosis and treatment recommendations.',
    analysisConsultFallback: 'Consult with Dr. Harshit Ranpata at ADIVA Center for personalized recommendations.',
    pdfAccent: '#EA580C',
    pdfAccentDark: null,
    pdfAccentLight: null,
    reportIdPrefix: 'SKN',
    footerName: 'Dr. Harshit Ranpata',
    footerExtra: null,
    pdfContactExtraLine: null,
    followUpColors: { bg: '#FFF7ED', border: '#EA580C', text: '#9A3412' },
    contactSectionBg: 'primary',
    keyConcernsBadge: { bg: '#FFEDD5', color: '#9A3412' },
    pdfClinicName: 'ADIVA Center for Skin and Hair, Rajkot',
    pdfPhone: '+91 96245 59193',
    pdfAddress: 'ADIVA Clinic, Bhakti Nagar',
    pdfDisclaimer: 'This AI-powered skin analysis is for informational purposes only. Please consult Dr. Harshit Ranpata at ADIVA Center for Skin and Hair for professional diagnosis and treatment.'
  },
  vishalchugh: {
    name: 'Dr. Vishal Chugh',
    clinic: 'Radiant Skin Clinic',
    address: 'Geejgarh House, Hawa Sadak, Civil Lines, Jaipur, Rajasthan',
    phone: '+917062161000',
    whatsappUrl: 'https://wa.me/917062161000?text=Hello%2C%20I%20just%20finished%20my%20AI%20skin%20analysis+%20from%20your%20website%20at%20Radiant%20Skin%20Clinic.%20I%20would%20like%20to%20book%20a%20consultation%20with%20you.',
    bookingUrl: null,
    mapsUrl: 'https://maps.app.goo.gl/i85Q9btThLJyMTVR7',
    photoUrl: '/assets/vishalchugh.jpg',
    logoUrl: '/assets/vishalchugh.svg',
    logoAlt: 'Radiant Skin Clinic',
    slug: 'vishalchugh',
    initials: 'VC',
    branches: null,
    welcomeStyle: 'split-pane',
    photoSize: 'large',
    photoBorderClass: 'border-2',
    photoObjectClass: 'object-top',
    accentColor: '#78001B',
    accentColorDark: '#520012',
    leftPaneSubtitleColor: 'text-[#E6CCD4]',
    rightPaneBg: 'bg-[#F5EDF1]',
    clinicNameColor: 'text-[#78001B]',
    fetchedImageBorder: 'border-[#E6CCD4]',
    fetchedImageFallbackFrom: null,
    fetchedImageFallbackTo: null,
    fetchedImageFallbackIcon: '#D9B3C2',
    featureCardIconBg: 'bg-[#E6CCD4]',
    contactLinkText: 'text-[#520012]',
    contactLinkBg: 'bg-[#E6CCD4]',
    contactLinkBorder: 'border-[#D9B3C2]',
    contactType: 'whatsapp',
    analysisAccent: '#4F46E5',
    analysisAccentDark: '#4F46E5',
    analysisAccentLight: '#4F46E5',
    analysisTimerColor: '#4F46E5',
    analysisScanGradient: false,
    analysisProgressGradient: false,
    routineTheme: {
      card: 'bg-gradient-to-r from-purple-50 to-pink-50',
      iconBg: 'bg-purple-100',
      iconText: 'text-purple-600',
      titleText: 'text-purple-900',
      bodyText: 'text-purple-800'
    },
    analysisDisclaimerFallback: 'This AI analysis is for informational purposes only. Please consult with Dr. Vishal Chugh at Radiant Skin Clinic (+917062161000) for professional diagnosis and treatment recommendations.',
    analysisConsultFallback: 'Consult with Dr. Vishal Chugh for personalized recommendations.',
    pdfAccent: '#4F46E5',
    pdfAccentDark: null,
    pdfAccentLight: null,
    reportIdPrefix: 'SKN',
    footerName: 'Dr. Vishal Chugh',
    footerExtra: null,
    pdfContactExtraLine: null,
    followUpColors: { bg: '#EEF2FF', border: '#4F46E5', text: '#3730A3' },
    contactSectionBg: 'primary',
    keyConcernsBadge: { bg: '#E0E7FF', color: '#4F46E5' },
    pdfClinicName: 'Radiant Skin Clinic, Jaipur',
    pdfPhone: '+91 70621 61000',
    pdfAddress: 'Geejgarh House, Civil Lines, Jaipur',
    pdfDisclaimer: 'This AI-powered skin analysis is for informational purposes only. Please consult Dr. Vishal Chugh for professional diagnosis and treatment.'
  },
  piyushborkhatariya: {
    name: 'Dr. Piyush Borkhatria',
    clinic: 'ESTHE Kayakalp Skin Hair Laser & Hair Transplant Clinic',
    address: 'Zanzarda, Junagadh, Gujarat 362015',
    phone: '+919023667994',
    whatsappUrl: 'https://wa.me/919023667994?text=Hello%2C%20I%20just%20finished%20my%20AI%20skin%20analysis+%20from%20your%20website%20at%20ESTHE%20Kayakalp%20Skin%20Hair%20Laser%20%26%20Hair%20Transplant%20Clinic.%20I%20would%20like%20to%20book%20a%20consultation%20with%20you.',
    bookingUrl: null,
    mapsUrl: 'https://maps.app.goo.gl/2KBzCSnzKeEnoYzE8',
    photoUrl: '/assets/piyush.jpg',
    logoUrl: '/assets/piyushborkhatria.svg',
    logoAlt: 'ESTHE Kayakalp',
    slug: 'piyushborkhatariya',
    initials: 'PB',
    branches: null,
    welcomeStyle: 'split-pane',
    photoSize: 'small',
    photoBorderClass: 'border-4',
    photoObjectClass: '',
    accentColor: '#DFB142',
    accentColorDark: '#C89A35',
    leftPaneSubtitleColor: 'text-[#F5E6C3]',
    rightPaneBg: 'bg-[#FDF8EF]',
    clinicNameColor: 'text-[#DFB142]',
    fetchedImageBorder: 'border-[#F5E6C3]',
    fetchedImageFallbackFrom: null,
    fetchedImageFallbackTo: null,
    fetchedImageFallbackIcon: '#E8D5A8',
    featureCardIconBg: 'bg-[#F5E6C3]',
    contactLinkText: 'text-[#A47E2E]',
    contactLinkBg: 'bg-[#F5E6C3]',
    contactLinkBorder: 'border-[#E8D5A8]',
    contactType: 'whatsapp',
    analysisAccent: '#F59E0B',
    analysisAccentDark: '#D97706',
    analysisAccentLight: '#FBBF24',
    analysisTimerColor: '#D97706',
    analysisScanGradient: false,
    analysisProgressGradient: false,
    routineTheme: {
      card: 'bg-gradient-to-r from-amber-50 to-yellow-50',
      iconBg: 'bg-amber-100',
      iconText: 'text-amber-600',
      titleText: 'text-amber-900',
      bodyText: 'text-amber-800'
    },
    analysisDisclaimerFallback: 'This AI analysis is for informational purposes only. Please consult with Dr. Piyush Borkhatariya at ESTHE Kayakalp Clinic for professional diagnosis and treatment recommendations.',
    analysisConsultFallback: 'Consult with Dr. Piyush Borkhatariya at ESTHE Kayakalp Clinic for personalized recommendations.',
    pdfAccent: '#D97706',
    pdfAccentDark: null,
    pdfAccentLight: '#F59E0B',
    reportIdPrefix: 'EST',
    footerName: 'Dr. Piyush Borkhatariya',
    footerExtra: null,
    pdfContactExtraLine: 'Zanzarda, Junagadh, Gujarat 362015',
    followUpColors: { bg: '#FFF7ED', border: '#F97316', text: '#9A3412' },
    contactSectionBg: 'accent',
    keyConcernsBadge: { bg: '#FEF3C7', color: '#92400E' },
    pdfClinicName: 'ESTHE Kayakalp Skin Hair Laser & Hair Transplant Clinic',
    pdfPhone: '+91 90236 67994',
    pdfAddress: 'contact@esthekayakalp.in',
    pdfDisclaimer: 'This AI-powered skin analysis is for informational purposes only. Please consult Dr. Piyush Borkhatariya at ESTHE Kayakalp Clinic for professional diagnosis and treatment.'
  },
  geetanjalishetty: {
    name: 'Dr. Geetanjali Shetty',
    clinic: 'Revitalis',
    address: 'Goregaon West, Mumbai, Maharashtra 400105',
    phone: '+919619364666',
    whatsappUrl: 'https://wa.me/919619364666?text=Hello%2C%20I%20just%20completed%20my%20AI%20Skin%20Analysis+%20and%20would%20like%20to%20consult%20with%20you.',
    bookingUrl: null,
    mapsUrl: 'https://maps.app.goo.gl/RhuL5Y7meVtAvJRBA',
    photoUrl: '/assets/geetanjalishetty.jpg',
    logoUrl: '/assets/geetanjalishetty.svg',
    logoAlt: 'Revitalis',
    slug: 'geetanjalishetty',
    initials: 'GS',
    branches: null,
    welcomeStyle: 'split-pane',
    photoSize: 'small',
    photoBorderClass: 'border-4',
    photoObjectClass: 'object-[center_20%]',
    accentColor: '#C62044',
    accentColorDark: '#A51B39',
    leftPaneSubtitleColor: 'text-[#F5CEDA]',
    rightPaneBg: 'bg-[#FBF0F3]',
    clinicNameColor: 'text-[#C62044]',
    fetchedImageBorder: 'border-[#F5CEDA]',
    fetchedImageFallbackFrom: null,
    fetchedImageFallbackTo: null,
    fetchedImageFallbackIcon: '#EEB3C5',
    featureCardIconBg: 'bg-[#F5CEDA]',
    contactLinkText: 'text-[#8A1630]',
    contactLinkBg: 'bg-[#F5CEDA]',
    contactLinkBorder: 'border-[#EEB3C5]',
    contactType: 'whatsapp',
    analysisAccent: '#7C3AED',
    analysisAccentDark: '#7C3AED',
    analysisAccentLight: '#7C3AED',
    analysisTimerColor: '#7C3AED',
    analysisScanGradient: false,
    analysisProgressGradient: false,
    routineTheme: {
      card: 'bg-gradient-to-r from-purple-50 to-violet-50',
      iconBg: 'bg-purple-100',
      iconText: 'text-purple-600',
      titleText: 'text-purple-900',
      bodyText: 'text-purple-800'
    },
    analysisDisclaimerFallback: 'This AI analysis is for informational purposes only. Please consult with Dr. Geetanjali Shetty at Revitalis (+919619364666) for professional diagnosis and treatment recommendations.',
    analysisConsultFallback: 'Consult with Dr. Geetanjali Shetty at Revitalis for personalized recommendations.',
    pdfAccent: '#7C3AED',
    pdfAccentDark: null,
    pdfAccentLight: null,
    reportIdPrefix: 'SKN',
    footerName: 'Dr. Geetanjali Shetty',
    footerExtra: null,
    pdfContactExtraLine: null,
    followUpColors: { bg: '#F5F3FF', border: '#7C3AED', text: '#5B21B6' },
    contactSectionBg: 'primary',
    keyConcernsBadge: { bg: '#EDE9FE', color: '#5B21B6' },
    pdfClinicName: 'Revitalis, Goregaon West, Mumbai',
    pdfPhone: '+91 96193 64666',
    pdfAddress: 'Revitalis Clinic',
    pdfDisclaimer: 'This AI-powered skin analysis is for informational purposes only. Please consult Dr. Geetanjali Shetty at Revitalis for professional diagnosis and treatment.'
  },
  adityashah: {
    name: 'Dr. Aditya Shah',
    clinic: 'Aura Laser & Cosmetic Clinic',
    address: 'RC Dutt Rd, Vadodara, Gujarat 390007',
    phone: '+919081090555',
    whatsappUrl: 'https://wa.me/919081090555?text=Hello%2C%20I%20just%20finished%20my%20AI%20skin%20analysis+%20from%20your%20website%20at%20Aura%20Laser%20%26%20Cosmetic%20Clinic.%20I%20would%20like%20to%20book%20a%20consultation%20with%20you.',
    bookingUrl: null,
    mapsUrl: 'https://maps.app.goo.gl/ANKbqdbSTmeQxxVD7',
    photoUrl: '/assets/Adityashah.jpg',
    logoUrl: '/assets/adityashah.svg',
    logoAlt: 'Aura Clinic',
    slug: 'adityashah',
    initials: 'AS',
    branches: [
      { name: 'Vadodara', address: 'RC Dutt Rd, Vadodara, Gujarat 390007', mapsUrl: 'https://maps.app.goo.gl/ANKbqdbSTmeQxxVD7', isMain: true },
      { name: 'Surat', address: 'Surat, Gujarat', mapsUrl: 'https://maps.app.goo.gl/aa9U8vjLrYgw6g7J6', isMain: false },
      { name: 'Ranchi', address: 'Ranchi, Jharkhand', mapsUrl: 'https://maps.app.goo.gl/eYThPrPAnvbPN3mo6', isMain: false }
    ],
    welcomeStyle: 'split-pane',
    photoSize: 'small',
    photoBorderClass: 'border-4',
    photoObjectClass: '',
    accentColor: '#EF89B6',
    accentColorDark: '#CB749B',
    leftPaneSubtitleColor: 'text-[#FCE4EE]',
    rightPaneBg: 'bg-[#FEF6FA]',
    clinicNameColor: 'text-[#EF89B6]',
    fetchedImageBorder: 'border-[#FCE4EE]',
    fetchedImageFallbackFrom: null,
    fetchedImageFallbackTo: null,
    fetchedImageFallbackIcon: '#F9C7DC',
    featureCardIconBg: 'bg-[#FCE4EE]',
    contactLinkText: 'text-[#B06485]',
    contactLinkBg: 'bg-[#FCE4EE]',
    contactLinkBorder: 'border-[#F9C7DC]',
    contactType: 'whatsapp',
    analysisAccent: '#EF89B6',
    analysisAccentDark: '#CB749B',
    analysisAccentLight: '#EF89B6',
    analysisTimerColor: '#EF89B6',
    analysisScanGradient: true,
    analysisProgressGradient: true,
    routineTheme: {
      card: 'bg-gradient-to-r from-purple-50 to-pink-50',
      iconBg: 'bg-purple-100',
      iconText: 'text-purple-600',
      titleText: 'text-purple-900',
      bodyText: 'text-purple-800'
    },
    analysisDisclaimerFallback: 'This AI analysis is for informational purposes only. Please consult with Dr. Aditya Shah at Aura Laser & Cosmetic Clinic for professional diagnosis and treatment recommendations.',
    analysisConsultFallback: 'Consult with Dr. Aditya Shah at Aura Laser & Cosmetic Clinic for personalized recommendations.',
    pdfAccent: '#EF89B6',
    pdfAccentDark: '#CB749B',
    pdfAccentLight: null,
    reportIdPrefix: 'AUR',
    footerName: 'Dr. Aditya Shah',
    footerExtra: 'Vadodara (HQ) • Surat • Ranchi',
    pdfContactExtraLine: null,
    followUpColors: { bg: '#FFF7ED', border: '#F97316', text: '#9A3412' },
    contactSectionBg: 'gradient',
    keyConcernsBadge: { bg: '#FCE7F3', color: '#9D174D' },
    pdfClinicName: 'Aura Laser & Cosmetic Clinic',
    pdfPhone: '+91 90810 90555',
    pdfAddress: 'contact@auraclinic.in',
    pdfDisclaimer: 'This AI-powered skin analysis is for informational purposes only. Please consult Dr. Aditya Shah at Aura Laser & Cosmetic Clinic for professional diagnosis and treatment.'
  },
  bschandrashekhar: {
    name: 'Dr. B. S. Chandrashekhar',
    clinic: 'Cutis Clinic',
    address: 'L373, 6th sector, HSR Layout, Bengaluru, Karnataka 560102',
    phone: '+918970822333',
    whatsappUrl: null,
    bookingUrl: 'https://appointment.cutis.org.in/',
    mapsUrl: 'https://maps.app.goo.gl/XYdzuCxzvpH1maZu9',
    photoUrl: '/assets/bs.webp',
    logoUrl: '/assets/bschandrashekhar.svg',
    logoAlt: 'Cutis Clinic',
    slug: 'bschandrashekhar',
    initials: 'BS',
    branches: null,
    welcomeStyle: 'split-pane',
    photoSize: 'small',
    photoBorderClass: 'border-4',
    photoObjectClass: 'object-[center_20%]',
    accentColor: '#19AA38',
    accentColorDark: '#158F2E',
    leftPaneSubtitleColor: 'text-[#D0F0D9]',
    rightPaneBg: 'bg-[#EBF9EE]',
    clinicNameColor: 'text-[#19AA38]',
    fetchedImageBorder: 'border-[#D0F0D9]',
    fetchedImageFallbackFrom: null,
    fetchedImageFallbackTo: null,
    fetchedImageFallbackIcon: '#B5E5C0',
    featureCardIconBg: 'bg-[#D0F0D9]',
    contactLinkText: 'text-[#117825]',
    contactLinkBg: 'bg-[#D0F0D9]',
    contactLinkBorder: 'border-[#B5E5C0]',
    contactType: 'booking',
    analysisAccent: '#B91C1C',
    analysisAccentDark: '#B91C1C',
    analysisAccentLight: '#B91C1C',
    analysisTimerColor: '#B91C1C',
    analysisScanGradient: false,
    analysisProgressGradient: false,
    routineTheme: {
      card: 'bg-gradient-to-r from-purple-50 to-red-50',
      iconBg: 'bg-purple-100',
      iconText: 'text-purple-600',
      titleText: 'text-purple-900',
      bodyText: 'text-purple-800'
    },
    analysisDisclaimerFallback: 'This AI analysis is for informational purposes only. Please consult with Dr. B. S. Chandrashekhar at Cutis Clinic (+918970822333) for professional diagnosis and treatment recommendations.',
    analysisConsultFallback: 'Consult with Dr. B. S. Chandrashekhar at Cutis Clinic for personalized recommendations.',
    pdfAccent: '#B91C1C',
    pdfAccentDark: null,
    pdfAccentLight: null,
    reportIdPrefix: 'SKN',
    footerName: 'Dr. B. S. Chandrashekhar',
    footerExtra: null,
    pdfContactExtraLine: null,
    followUpColors: { bg: '#FEF2F2', border: '#B91C1C', text: '#991B1B' },
    contactSectionBg: 'primary',
    keyConcernsBadge: { bg: '#FEE2E2', color: '#991B1B' },
    pdfClinicName: 'Cutis Clinic, HSR Layout, Bengaluru',
    pdfPhone: '+91 89708 22333',
    pdfAddress: 'appointment.cutis.org.in',
    pdfDisclaimer: 'This AI-powered skin analysis is for informational purposes only. Please consult Dr. B. S. Chandrashekhar at Cutis Clinic for professional diagnosis and treatment.'
  },
  prashantagrawal: {
    name: 'Dr. Prashant Agrawal',
    clinic: 'Dermadent Clinic',
    address: 'Meera Nagar, Udaipur, Rajasthan 313001',
    phone: '+919352082112',
    whatsappUrl: 'https://wa.me/919352082112?text=Hello%2C%20I%20just%20finished%20my%20AI%20skin%20analysis+%20from%20your%20website%20at%20Dermadent%20Clinic.%20I%20would%20like%20to%20book%20a%20consultation%20with%20you.',
    bookingUrl: null,
    mapsUrl: 'https://maps.app.goo.gl/LQnMGf6GyCBoYJJz8',
    photoUrl: '/assets/PrashantAgrawal.jpg',
    logoUrl: '/assets/Prashantagrawal.svg',
    logoAlt: 'Dermadent Clinic',
    slug: 'prashantagrawal',
    initials: 'PA',
    branches: null,
    welcomeStyle: 'split-pane',
    photoSize: 'small',
    photoBorderClass: 'border-4',
    photoObjectClass: 'object-[center_bottom]',
    accentColor: '#D9B265',
    accentColorDark: '#B99856',
    leftPaneSubtitleColor: 'text-[#F5E9CD]',
    rightPaneBg: 'bg-[#FBF6E8]',
    clinicNameColor: 'text-[#D9B265]',
    fetchedImageBorder: 'border-[#F5E9CD]',
    fetchedImageFallbackFrom: null,
    fetchedImageFallbackTo: null,
    fetchedImageFallbackIcon: '#EED9A9',
    featureCardIconBg: 'bg-[#F5E9CD]',
    contactLinkText: 'text-[#9E814A]',
    contactLinkBg: 'bg-[#F5E9CD]',
    contactLinkBorder: 'border-[#EED9A9]',
    contactType: 'whatsapp',
    analysisAccent: '#92400E',
    analysisAccentDark: '#92400E',
    analysisAccentLight: '#92400E',
    analysisTimerColor: '#92400E',
    analysisScanGradient: false,
    analysisProgressGradient: false,
    routineTheme: {
      card: 'bg-gradient-to-r from-purple-50 to-pink-50',
      iconBg: 'bg-purple-100',
      iconText: 'text-purple-600',
      titleText: 'text-purple-900',
      bodyText: 'text-purple-800'
    },
    analysisDisclaimerFallback: 'This AI analysis is for informational purposes only. Please consult with Dr. Prashant Agrawal at Dermadent Clinic (+919352082112) for professional diagnosis and treatment recommendations.',
    analysisConsultFallback: 'Consult with Dr. Prashant Agrawal for personalized recommendations.',
    pdfAccent: '#92400E',
    pdfAccentDark: null,
    pdfAccentLight: null,
    reportIdPrefix: 'SKN',
    footerName: 'Dr. Prashant Agrawal',
    footerExtra: null,
    pdfContactExtraLine: null,
    followUpColors: { bg: '#FFF7ED', border: '#F97316', text: '#9A3412' },
    contactSectionBg: 'primary',
    keyConcernsBadge: { bg: '#FEF3C7', color: '#92400E' },
    pdfClinicName: 'Dermadent Clinic, Udaipur',
    pdfPhone: '+91 93520 82112',
    pdfAddress: 'Meera Nagar, Udaipur, Rajasthan',
    pdfDisclaimer: 'This AI-powered skin analysis is for informational purposes only. Please consult Dr. Prashant Agrawal for professional diagnosis and treatment.'
  },
  amandua: {
    name: 'Dr. Aman Dua',
    clinic: 'AK Clinic',
    address: 'Sarabha Nagar, Ludhiana, Punjab 141001',
    phone: '+918283812207',
    whatsappUrl: 'https://wa.me/918283812207?text=Hello%2C%20I%20just%20finished%20my%20AI%20skin%20analysis+%20from%20your%20website%20at%20AK%20Clinic.%20I%20would%20like%20to%20book%20a%20consultation%20with%20you.',
    bookingUrl: null,
    mapsUrl: 'https://maps.app.goo.gl/a6fmqsrAjdKGYaXP9',
    photoUrl: '/assets/amandua.jpg',
    logoUrl: '/assets/amandua.svg',
    logoAlt: 'AK Clinic',
    slug: 'amandua',
    initials: 'AD',
    branches: null,
    welcomeStyle: 'split-pane',
    photoSize: 'small',
    photoBorderClass: 'border-4',
    photoObjectClass: '',
    accentColor: '#F97825',
    accentColorDark: '#D4651F',
    leftPaneSubtitleColor: 'text-[#FDE5D5]',
    rightPaneBg: 'bg-[#FEF5EE]',
    clinicNameColor: 'text-[#F97825]',
    fetchedImageBorder: 'border-[#FDE5D5]',
    fetchedImageFallbackFrom: null,
    fetchedImageFallbackTo: null,
    fetchedImageFallbackIcon: '#FCCCAA',
    featureCardIconBg: 'bg-[#FDE5D5]',
    contactLinkText: 'text-[#B9561A]',
    contactLinkBg: 'bg-[#FDE5D5]',
    contactLinkBorder: 'border-[#FCCCAA]',
    contactType: 'whatsapp',
    analysisAccent: '#10B981',
    analysisAccentDark: '#059669',
    analysisAccentLight: '#34D399',
    analysisTimerColor: '#059669',
    analysisScanGradient: false,
    analysisProgressGradient: false,
    routineTheme: {
      card: 'bg-gradient-to-r from-emerald-50 to-teal-50',
      iconBg: 'bg-emerald-100',
      iconText: 'text-emerald-600',
      titleText: 'text-emerald-900',
      bodyText: 'text-emerald-800'
    },
    analysisDisclaimerFallback: 'This AI analysis is for informational purposes only. Please consult with Dr. Aman Dua at AK Clinic for professional diagnosis and treatment recommendations.',
    analysisConsultFallback: 'Consult with Dr. Aman Dua at AK Clinic for personalized recommendations.',
    pdfAccent: '#059669',
    pdfAccentDark: null,
    pdfAccentLight: '#10B981',
    reportIdPrefix: 'AKC',
    footerName: 'Dr. Aman Dua',
    footerExtra: null,
    pdfContactExtraLine: 'Sarabha Nagar, Ludhiana, Punjab 141001',
    followUpColors: { bg: '#FFF7ED', border: '#F97316', text: '#9A3412' },
    contactSectionBg: 'accent',
    keyConcernsBadge: { bg: '#D1FAE5', color: '#065F46' },
    pdfClinicName: 'AK Clinic',
    pdfPhone: '+91 82838 12207',
    pdfAddress: 'contact@akclinic.in',
    pdfDisclaimer: 'This AI-powered skin analysis is for informational purposes only. Please consult Dr. Aman Dua at AK Clinic for professional diagnosis and treatment.'
  },
  rohanbhattacharjee: {
    name: 'Dr. Rohan Bhattacharjee',
    clinic: "Dr. Rohan's Skin, LASERs, & Hair transplantation clinic",
    address: 'Avishkar Diagnostics, CA-03, Ambedkar Sarani, Ambuja, Durgapur, West Bengal 713216',
    phone: '+918972587077',
    whatsappUrl: 'https://wa.me/918972587077?text=Hello%2C%20I%20just%20finished%20my%20AI%20skin%20analysis%20from%20your%20website.%20I%20would%20like%20to%20book%20a%20consultation%20with%20you.',
    bookingUrl: null,
    mapsUrl: 'https://maps.app.goo.gl/9pWx9bwV1Dnu4uHc6',
    photoUrl: '/assets/rohanbhattacharjee.jpg',
    logoUrl: '/assets/rohanbhattacharjee.svg',
    logoAlt: "Dr. Rohan's Clinic",
    slug: 'rohanbhattacharjee',
    initials: 'RB',
    branches: null,
    welcomeStyle: 'split-pane',
    photoSize: 'small',
    photoBorderClass: 'border-4',
    photoObjectClass: '',
    accentColor: '#B32C29',
    accentColorDark: '#7A1D1B',
    leftPaneSubtitleColor: 'text-[#F7D0D0]',
    rightPaneBg: 'bg-[#FCF2F2]',
    clinicNameColor: 'text-[#8E2320]',
    fetchedImageBorder: 'border-[#EDA8A8]',
    fetchedImageFallbackFrom: null,
    fetchedImageFallbackTo: null,
    fetchedImageFallbackIcon: '#EDA8A8',
    featureCardIconBg: 'bg-[#F7D0D0]',
    contactLinkText: 'text-[#7A1D1B]',
    contactLinkBg: 'bg-[#F7D0D0]',
    contactLinkBorder: 'border-[#EDA8A8]',
    contactType: 'whatsapp',
    analysisAccent: '#B32C29',
    analysisAccentDark: '#B32C29',
    analysisAccentLight: '#B32C29',
    analysisTimerColor: '#B32C29',
    analysisScanGradient: false,
    analysisProgressGradient: false,
    routineTheme: {
      card: 'bg-gradient-to-r from-purple-50 to-pink-50',
      iconBg: 'bg-purple-100',
      iconText: 'text-purple-600',
      titleText: 'text-purple-900',
      bodyText: 'text-purple-800'
    },
    analysisDisclaimerFallback: "This AI analysis is for informational purposes only. Please consult with Dr. Rohan Bhattacharjee at Dr. Rohan's Skin, LASERs, & Hair transplantation clinic (+918972587077) for professional diagnosis and treatment recommendations.",
    analysisConsultFallback: 'Consult with Dr. Rohan Bhattacharjee for personalized recommendations.',
    pdfAccent: '#B32C29',
    pdfAccentDark: null,
    pdfAccentLight: null,
    reportIdPrefix: 'SKN',
    footerName: 'Dr. Rohan Bhattacharjee',
    footerExtra: null,
    pdfContactExtraLine: null,
    followUpColors: { bg: '#FAE0E0', border: '#B32C29', text: '#640600' },
    contactSectionBg: 'primary',
    keyConcernsBadge: { bg: '#FEE0E0', color: '#B32C29' },
    pdfClinicName: "Dr. Rohan's Skin, LASERs, & Hair transplantation clinic, Durgapur",
    pdfPhone: '+91 89725 87077',
    pdfAddress: 'Avishkar Diagnostics, Ambedkar Sarani, Durgapur',
    pdfDisclaimer: 'This AI-powered skin analysis is for informational purposes only. Please consult Dr. Rohan Bhattacharjee for professional diagnosis and treatment.'
  }
};

Object.assign(DOCTOR_CONFIGS, BATCH_DOCTOR_CONFIGS);

const SLUG_ALIASES = {
  Janakthakkar: 'janakthakkar',
  Smitthakkar: 'smitthakkar',
  smitthakker: 'smitthakkar',
  Smitthakker: 'smitthakkar',
  Apratimgoel: 'apratimgoel',
  'apratim-goel': 'apratimgoel',
  Oladerm: 'apratimgoel',
  oladerm: 'apratimgoel',
  harshitranpata: 'harshitranpara',
  piyushborkhatria: 'piyushborkhatariya',
  geetanjalisheety: 'geetanjalishetty',
  prashantagarwal: 'prashantagrawal',
  Prashantagrawal: 'prashantagrawal'
};

export function getDoctorConfig(slug) {
  const normalizedSlug = slug?.toLowerCase();
  const resolvedSlug = SLUG_ALIASES[slug] || SLUG_ALIASES[normalizedSlug] || normalizedSlug;
  return DOCTOR_CONFIGS[resolvedSlug] || null;
}

export function getAllDoctorSlugs() {
  const slugs = Object.keys(DOCTOR_CONFIGS);
  const aliases = Object.keys(SLUG_ALIASES);
  return [...slugs, ...aliases];
}

export default DOCTOR_CONFIGS;
